export const SESSION_DETAILS = [
	"coaching-thirty",
	"coaching-sixty",
	"therapy-thirty",
	"therapy-sixty",
	"completed-no-show"
]
